import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import {useListStyles} from './MenuStyles';
import {NavigationPath} from '../SelectedIndexUtil';
import Anchor from '../../../../common/Anchor';

interface IProps {
  selectedIndex: NavigationPath;
  handleListItemClick: (navigationPath: NavigationPath) => void;
}

export const ItemsContractor: React.FC<IProps> = (props) => {
  const classes = useListStyles();
  const {selectedIndex, handleListItemClick} = props;

  return (
    <List className={classes.listRoot}>
      <Anchor href={NavigationPath.RFPS}>
        <ListItem
          button
          key={NavigationPath.RFPS}
          selected={selectedIndex === NavigationPath.RFPS}
          onClick={() => handleListItemClick(NavigationPath.RFPS)}
          classes={{
            root: classes.listItemRoot,
            selected: classes.listItemSelected,
          }}>
          <ListItemText
            primaryTypographyProps={{variant: 'subtitle2'}}
            primary="OPEN JOBS"
          />
        </ListItem>
      </Anchor>
      <Anchor href={NavigationPath.MY_AWARDED_RFPS}>
        <ListItem
          button
          key={NavigationPath.MY_AWARDED_RFPS}
          selected={selectedIndex === NavigationPath.MY_AWARDED_RFPS}
          onClick={() => handleListItemClick(NavigationPath.MY_AWARDED_RFPS)}
          classes={{
            root: classes.listItemRoot,
            selected: classes.listItemSelected,
          }}>
          <ListItemText
            primaryTypographyProps={{variant: 'subtitle2'}}
            primary="MY PROJECTS"
          />
        </ListItem>
      </Anchor>
      <Anchor href={NavigationPath.MY_SITE_VISITS}>
        <ListItem
          button
          key={NavigationPath.MY_SITE_VISITS}
          selected={selectedIndex === NavigationPath.MY_SITE_VISITS}
          onClick={() => handleListItemClick(NavigationPath.MY_SITE_VISITS)}
          classes={{
            root: classes.listItemRoot,
            selected: classes.listItemSelected,
          }}>
          <ListItemText
            primaryTypographyProps={{variant: 'subtitle2'}}
            primary="SITE VISITS"
          />
        </ListItem>
      </Anchor>
      <Anchor href={NavigationPath.MY_PROPOSALS}>
        <ListItem
          button
          disableGutters
          key={NavigationPath.MY_PROPOSALS}
          selected={selectedIndex === NavigationPath.MY_PROPOSALS}
          onClick={() => handleListItemClick(NavigationPath.MY_PROPOSALS)}
          classes={{
            root: classes.listItemRoot,
            selected: classes.listItemSelected,
          }}>
          <ListItemText
            primaryTypographyProps={{variant: 'subtitle2'}}
            primary="QUOTES"
          />
        </ListItem>
      </Anchor>
    </List>
  );
};
